import React from 'react';
import CustomDeletePage from 'components/custom-pages/CustomDelete';

const Delete = ({ data, handleClick }) => {
  return (
    <CustomDeletePage
      pageTitle={'Delete product master'}
      url={'product-master'}
      queryKey="product-master"
      title={'Product Master'}
      id={data?._id}
      handleClick={handleClick}
    />
  );
};

export default Delete;
